export const BROWSE_PRESENT_LEVELS_EVENT_NAMES = {
  VIEWED_PAGE: 'Viewed Browse Present Levels Page',
  VIEWED_STATEMENT: 'Viewed Browse Present Levels Statement',
  SELECTED_GRADE: 'Selected Browse Present Levels Grade',
  SELECTED_SUBJECT: 'Selected Browse Present Levels Subject',
  SELECTED_CATEGORY: 'Selected Browse Present Levels Category',
  SELECTED_LEVEL: 'Selected Browse Present Levels Level',
  EDITED_STATEMENT: 'Edited Browse Present Levels Statement'
}
